import { LocationRequest } from '@pxtra-client-lib-legacy/gen';
import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { useStore } from '../../../../../hooks/useStore';
import { DataViewEditBox, useForm } from '../../../../../lib/components';
import { LocationDataForm } from './form';

export const LocationData = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { companyStore } = useStore();
  const params = useParams();
  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  const form = useForm();

  const renderEdit = () => {
    return (
      <LocationDataForm
        initialValues={{
          name: companyStore.locations?.filter((l) => l.id === params.locationId)[0]?.name || '',
          active:
            companyStore.locations?.filter((l) => l.id === params.locationId)[0]?.active || false
        }}
        formRef={form.formRef}
        onStateChanged={setCanSubmit}
        onSubmit={async (values) => {
          try {
            if (params.locationId === 'new') {
              await companyStore.createLocation(values as LocationRequest);
              navigate(-1);
            } else if (params.locationId) {
              await companyStore.updateLocationData(params.locationId, values);
            }
          } catch (error) {
            console.error(error);
          }
        }}
        useCustomButton
      />
    );
  };

  useEffect(() => {
    const abortController = new AbortController();

    const fetchLocations = async () => {
      if (companyStore.locations && companyStore.locations?.length > 0) return;
      try {
        await companyStore.fetchLocations();
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error(error);
        }
      }
    };
    fetchLocations();

    return () => abortController.abort();
  }, [companyStore.company?.id]);

  return (
    <DataViewEditBox
      title={t('company:LOCATION', { context: params.locationId === 'new' ? 'new' : undefined })}
      view={() => <></>}
      edit={renderEdit}
      canEdit={params.locationId !== 'new'}
      initMode={'edit'}
      canSubmit={canSubmit}
      onSubmit={() => {
        form.handleSubmit();
        navigate(-1);
      }}
      onCancel={() => {
        form.handleReset();
        navigate(-1);
      }}
    />
  );
});
